// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyArgNoY7luYCUYJlVAxapXEjw2nuDu5Ny8",
  authDomain: "log-trade-dev.firebaseapp.com",
  projectId: "log-trade-dev",
  storageBucket: "log-trade-dev.appspot.com",
  messagingSenderId: "427284527632",
  appId: "1:427284527632:web:9232621b47da1f73dca895"
};

// Initialize Firebase
// eslint-disable-next-line no-unused-vars
const app = initializeApp(firebaseConfig);